//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Switch } from "antd";
import { Tooltip } from "@vibe/core";
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalBasicLayout } from "@vibe/core/next";
import { Info } from "@vibe/icons";
import { SettingsSwitchPropsInterface } from "./types/settings-drawer-interface";
import logger from "../../../lib/logger";

export const SettingSwitch = ({
  label,
  initialValue,
  setNewValue,
  settingKey,
  updateFunction,
  tooltip,
  hasModal = false,
  interceptChange,
}: SettingsSwitchPropsInterface) => {
  const [showModal, setShowModal] = useState(false);
  const [switchState, setSwitchState] = useState(initialValue);

  useEffect(() => {
    if (initialValue !== undefined) {
      setSwitchState(initialValue);
    }
  }, [initialValue]);

  const handleSwitch = async (checked: boolean) => {
    const newValue = checked;

    if (interceptChange) {
      try {
        if (!(await interceptChange(checked))) return;
      } catch (err: any) {
        logger.error(`Failed to check ${label.toLowerCase()} change:`, err);
        return;
      }
    }

    setNewValue((prevSettings) => ({
      ...prevSettings,
      [settingKey]: newValue,
    }));

    setSwitchState(newValue);

    try {
      if (!hasModal || (hasModal && !checked)) {
        await updateFunction(newValue);
      } else if (checked) {
        setShowModal(true);
      }
    } catch (err: any) {
      logger.error(`Failed to update ${label.toLowerCase()}:`, err);

      // setSwitchState(!newValue); // Revert change on error
    } finally {
    }
  };

  const confirmModal = async () => {
    try {
      if (hasModal) {
        setNewValue((prevSettings) => ({
          ...prevSettings,
          [settingKey]: true,
        }));
        await updateFunction(true);
      }
    } catch (error: any) {
      logger.error("Error confirming move item setting", error);
    } finally {
      setShowModal(false);
    }
  };

  const cancelModal = async () => {
    try {
      await updateFunction(!switchState);
      setShowModal(false);
      setSwitchState(!switchState);
    } catch (error: any) {
      logger.error("Error canceling modal settings", error);
    }
  };

  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-row gap-1">
        <div>
          <p className="text-sm">{label}</p>
        </div>
        {tooltip && (
          <div className="flex items-center">
            <Tooltip zIndex={1210} content={tooltip}>
              <Info />
            </Tooltip>
          </div>
        )}
      </div>
      <Switch
        aria-label={label}
        checked={switchState}
        onChange={(checked) => {
          handleSwitch(checked);
        }}
      />

      {hasModal && showModal && (
        <Modal show={showModal} id="story-book-modal" onClose={() => cancelModal()} size="medium">
          <ModalBasicLayout>
            <ModalHeader title="Support moving items to boards" className="px-8" />
            <ModalContent>
              <p>
                Enabling this will install the <b>"When an item is moved to any group"</b> webhook.
                This will take effect after 30 minutes.
              </p>
            </ModalContent>
          </ModalBasicLayout>
          <ModalFooter
            primaryButton={{
              onClick: confirmModal,
              text: "Confirm",
            }}
            secondaryButton={{
              onClick: () => cancelModal(),
              text: "Cancel",
            }}
          />
        </Modal>
      )}
    </div>
  );
};
